<template>
  <section>
    <div class="container">
      <div v-if="fill_info == '' && subpage == 'open'" class="row">
        <div class="col-xs-12">
          <div class="form-title">Felhívás, formai kritériumok</div>
          <PerfectScrollbar :options="{wheelPropagation: false, handlers:['click-rail', 'drag-thumb', 'keyboard', 'wheel', 'touch']}" style="height: 50vh; border: 1px solid #f4f4f4; padding: 20px 20px 0px 20px; margin-bottom: 20px;">
          <div class="article-text medium">
            <p>A következő <strong>formai kritériumok</strong> szerint kérjük leadni az anyagokat:</p>
            <ul class="ordered-list with-icon" style="padding-bottom: 20px;">
              <li><i class="fa fa-angle-right"></i><strong>Teljes terjedelem (ábrákkal, forrásjegyzékkel együtt):</strong> minimum 4 db, maximum 8 db A4-es méretű oldal</li>
              <li><i class="fa fa-angle-right"></i><strong>Betűtípus:</strong> 12 pt, Times New Roman betűtípus</li>
              <li><i class="fa fa-angle-right"></i><strong>1,5-es sorköz</strong></li>
              <li><i class="fa fa-angle-right"></i><strong>Margó:</strong> normál, minden oldalon 2,5-ös</li>
              <li><i class="fa fa-angle-right"></i>Az <strong>ábrákat, fotókat a szövegbe illesztve</strong> kérjük</li>
              <li><i class="fa fa-angle-right"></i><strong>Ábrák elnevezése</strong> pl.: 1. ábra: Ábra címe (forrás megjelölése – amennyiben releváns)</li>
              <li><i class="fa fa-angle-right"></i><strong>Az 1-es lábjegyzet az Ösztöndíjas és Témavezető adatait tartalmazza</strong> a következők szerint
                <ul>
                  <li><u>Ösztöndíjas neve</u> nyomtatott nagybetűvel</li>
                  <li><u>Szak és Kar/Tanszék és Kar/Doktori Iskola</u> (ahogy releváns)</li>
                  <li>Ugyanebben a lábjegyzetben kerüljön feltüntetésre a <u>Témavezető neve, beosztása, szervezeti egysége</u>.<br>
                    <br>
                    Példa:<br>
                    DOE JÁNOS <sup>1</sup><br><br>
                    Lábjegyzet az oldal alján:<br>
                    <sup>1</sup> XY szak, ZV Kar. <u>VAGY</u> XY Tanszék, ZV Kar <u>VAGY</u> Doktori Iskola neve (amelyik releváns) Témavezető: Dr. XY, egyetemi docens, Művészeti Kar, Szólóhangszerek és Művészetelmélet Tanszék
                  </li>
                </ul>
              </li>
              <li><i class="fa fa-angle-right"></i><strong>HIVATKOZÁSOK:</strong> MINDENKÉPP TÜNTESSETEK FEL FORRÁSJEGZYÉKET/FELHASZNÁLT IRODALMAT AZ ESSZÉ VÉGÉN. Bármely word-ben elérhető forráskezelés tökéletes (’Hivatkozások’ fül – Idézetek és Irodalomjegyzék – Stílusok), és bármilyen más, értelemszerű forrásjegyzék feltüntetési mód is rendben van.</li>
              <li><i class="fa fa-angle-right"></i><strong>Plagizálás teljes kizárása érdekében</strong> érdemes felkeresni a könyvtári kollégákat, és útmutatást kérni a Turnitin rendszer segítségével történő önellenőrzés kapcsán.</li>
            </ul>
            <p>Üdvözlettel:<em><br>EKÖP felelősök</em></p>
          </div>
          </PerfectScrollbar>
          <div style="display: flex; flex-wrap:wrap">
            <a style="margin-right: 10px" href="assets/pdf/ekop_tanulmanykotet_formai_kovetelmenyek.pdf" target="_blank" class="button with-icon"><i class="fa fa-download"></i>Formai követelmények letöltése</a>
            <button @click="subpage = 'data'" type="button" class="button">Tovább</button>
          </div>
        </div>
      </div>
      <div v-if="fill_info == '' && subpage == 'data'" class="row">
        <div class="col-xs-12">
          <div class="form-title">EKÖP Tanulmánykötet</div>
        </div>

        <div class="col-xs-12">
          <div class="info-box download">
            Az EKÖP Tanulmánykötetben szereplő írások formai követelményeit tartalmazó dokumentum <span class="highlight"><a target="_blank" href="assets/pdf/ekop_tanulmanykotet_formai_kovetelmenyek.pdf" title="Formai követelmények">ITT</a></span> tölthető le.
          </div>
        </div>
        <div class="col-sm-6">
          <inputbox id="nev" label="Viselt neve <span style='font-size: 10px; display: block; font-weight: 400'>(A dr-i, egyéb nevére vonatkozó előtagokat, a neve után vesszővel elválasztva tüntesse fel)</span>" name="nev" regexp_filter="[a-zA-ZöüóőúéáűíÖÜÓŐÚÉÁŰÍ. ,]+" v-model="form.nev" :errors="errors"/>
        </div>
        <div class="col-sm-6">
          <inputbox id="email" label="E-mail cím <span style='font-size: 10px; display: block; font-weight: 400'>(Pályázat beadásakor megadott)</span>" name="email" v-model="form.email" :errors="errors"/>
        </div>
        <div class="clearfix"></div>
        <div class="col-sm-6">
          <inputbox id="mobilszam" label="Mobilszám" mask="+99 99 / 999 9999" regexp_filter="[0-9]+" name="mobilszam" v-model="form.mobilszam" :errors="errors"/>
        </div>
        <div class="col-sm-6">
          <inputbox disabled id="neptunkod" label="Neptunkód" name="neptunkod" regexp_filter="[a-zA-Z0-9]+" v-model="form.neptunkod" :errors="errors"/>
        </div>
        <div class="clearfix"></div>
        <div class="col-sm-6">
          <inputbox id="palyazati_azonosito" label="Pályázati azonosító <span style='font-size: 10px; display: block; font-weight: 400'>(Az egyedi azonosító számot a pályázat befogadásáról szóló értesítő e-mail-ben kapta meg)</span>" name="palyazati_azonosito" v-model="form.palyazati_azonosito" :errors="errors"/>
        </div>
        <div class="clearfix"></div>
        <div class="col-xs-12">
          <UploadHandler max_uploaded_files="1" @change="(value) => { form.tanulmanykotet_dokumentum = value; }" accepted_files="application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document" :errors="errors" id="tanulmanykotet_dokumentum" label="EKÖP tanulmány <span style='font-size: 10px; display: block; font-weight: 400'>(A fájl elnevezése az ösztöndíjas előtagok nélküli neve és EKÖP tanulmány legyen. Pl. Györgyné_Kékesi_Ilona_EKÖP_tanulmány)</span>" name="tanulmanykotet_dokumentum" :loaded_files="form.tanulmanykotet_dokumentum"/>
        </div>
        <div class="col-xs-12">
          <UploadHandler max_uploaded_files="10" @change="(value) => { form.dokumentumok = value; }" accepted_files="image/jpeg,application/pdf,application/x-pdf" :errors="errors" id="dokumentumok" label="Ábrák / képek" name="dokumentumok" :loaded_files="form.dokumentumok"/>
        </div>
        <div class="col-xs-12">
          <div v-for="(url, i) in form.dokumentum_urlek" style="display: flex; align-items: center; margin-bottom: 5px;">
            <input type="text" placeholder="Külső Url (pl.: http://webcim.hu/dokumentum.pdf)" class="form-control" v-model="form.dokumentum_urlek[i]"/>
            <a :href="form.dokumentum_urlek[i]" target="_blank" style="margin-left: 5px;" class="button only-icon v2">
              <i class="fa fa-eye"></i>
            </a>
            <button @click="deleteUrl(i)" style="margin-left: 5px;" type="button" class="button only-icon">
              <i class="fa fa-trash-o"></i>
            </button>
          </div>
          <div style="display: flex; align-items: center; margin-bottom: 20px;">
            <input type="text" placeholder="Külső Url (pl.: http://webcim.hu/dokumentum.pdf)" class="form-control" v-model="uj_dokumentum_url">
            <button @click="addDocumentUrl" style="margin-left: 5px;" type="button" class="button only-icon v2">
              <i class="fa fa-plus"></i>
            </button>
          </div>
        </div>

        <div class="col-xs-12">
          <div style="display: flex; justify-content: space-between; align-items: center">
            <button v-on:click="save(1)" :disabled="saving" type="button" class="button">Mentés</button>
            <button v-on:click="save(2)" :disabled="saving" type="button" class="button">Véglegesít</button>
          </div>
        </div>
      </div>
      <div v-if="fill_info != ''" class="row">
        <div class="col-xs-12">
          <div class="form-title">EKÖP Tanulmánykötet</div>
          <div v-html="fill_info"></div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import Vue from 'vue';
import { PerfectScrollbar } from 'vue2-perfect-scrollbar';
import 'vue2-perfect-scrollbar/dist/vue2-perfect-scrollbar.css';

export default {
  components: {
    PerfectScrollbar
  },
  data: function() {
    return {
      saving: false,
      errors: [],
      fill_info: '',
      subpage: 'open',
      uj_dokumentum_url: '',
      form: {
        nev: '',
        neptunkod: '',
        email: '',
        mobilszam: '',
        palyazati_azonosito: '',
        dokumentumok: [],
        dokumentum_urlek: [],
        tanulmanykotet_dokumentum: []
      }
    }
  },

  computed: {
  },

  watch: {
  },

  mounted: function() {
    var _this = this;

  	Vue.nextTick(function() {
      $('.subpage-head-image').height($(window).innerHeight() * .25);
      $(window).scrollTop(0);
      setHeaderDarkLine();

      $(window).resize(function() {
        setHeaderDarkLine();
      });
    });

    this.$root.ajax('form/ekop_tanulmanykotet_ell/', {
      method: 'POST',
      data: {
        y: this.$route.query.y != undefined ? this.$route.query.y : ''
      },
      success: function(response) {
        if (response.error != false) {
          _this.fill_info = response.error;
          return;
        }

        if (response.fill != undefined) {
          _this.form = response.fill;

        } else {
          _this.form.nev = _this.$root.user.name;
          _this.form.email = _this.$root.user.email;
          _this.form.neptunkod = _this.$root.user.neptuncode;
        }
      }
    });
  },

  methods: {
    deleteUrl: function(i) {
      this.form.dokumentum_urlek.splice(i, 1);
    },

    addDocumentUrl: function() {
      if (this.uj_dokumentum_url != '') {
        this.form.dokumentum_urlek.push(this.uj_dokumentum_url);
        this.uj_dokumentum_url = '';
      }
    },

    save: function(veglegesit) {
      var _this = this;

      this.saving = true;
      this.errors = [];

      if (this.uj_dokumentum_url != '') {
        swal('Figyelem!', 'Az ábra/kép url-jét "+" jellel adja hozzá a listához.', 'error');
        this.saving = false;
        return;
      }

      this.$root.ajax('form/ekop_tanulmanykotet_ment/', {
        method: 'POST',
        data: {
          form: JSON.stringify(this.form),
          veglegesit: veglegesit,
          y: this.$route.query.y != undefined ? this.$route.query.y : ''
        },
        success: function(response) {
          _this.saving = false;

          if (response.errors != undefined && response.errors.length > 0) {
            _this.errors = response.errors;

            Vue.nextTick(function() {
              $('html, body').animate({
                scrollTop: $('#' + _this.errors[0].id).offset().top - 50
              }, 500);
            })

          } else if (response.error) {
            swal('Hiba!', response.error, 'error');

          } else {
            _this.fill_info = veglegesit == 1 ? 'Ön elmentette az űrlap kitöltését. Befogadáshoz Önnek véglegesítenie kell a kitöltését. Az űrlap megtekintéséhez kattintson az alábbi <a href="javascript:void(0)" onclick="location.reload()">linkre.</a>' : 'Köszönjük, Ön sikeresen véglegesítette az űrlap kitöltését.';
          }
        }
      });
    }
  }
}
</script>


// WEBPACK FOOTER //
// ekop_tanulmanykotet.vue?391e7ea6